module.exports = __webpack_public_path__ + "static/media/logo.fcc24b22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo.svg
// module id = 587
// module chunks = 7